import React, { FC } from 'react'
import { Redirect, Route, Switch } from 'react-router'

import { routes } from '../../../constants/routes'
import { General } from './General'

export const SettingsGeneralRoutes: FC = () => (
  <Switch>
    <Route path={routes.SETTINGS_GENERAL_TABS} component={General} />
    <Redirect to={routes.SETTINGS_GENERAL_TABS} />
  </Switch>
)
